import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs';
import { toDataSourceRequestString } from '@progress/kendo-data-query';
import { GridState } from '@shared';

@Injectable({
  providedIn: 'root',
})
export class ItemService {
  private apiUrl: string = environment.apiUrl + '/items';
  constructor(private httpClient: HttpClient) {}

  getImportUrl(): string {
    return `${this.apiUrl}/upload-document`;
  }

  getAllItems(
    state: GridState,
    showLegacyItems: boolean,
  ): Observable<GridDataResult> {
    const queryStr = toDataSourceRequestString(state);
    let params = new HttpParams({ fromString: queryStr });
    params = params.set('showLegacyItems', showLegacyItems);
    return this.httpClient.get<GridDataResult>(`${this.apiUrl}/all`, {
      params,
    });
  }

  batchUpdateItems(items: any): Observable<any> {
    const url = `${this.apiUrl}/bulk-update`;
    return this.httpClient.put(url, items);
  }

  unassignItem(itemId: number): Observable<void> {
    const url = `${this.apiUrl}/unassign?itemId=${itemId}`;
    return this.httpClient.patch<void>(url, null);
  }

  assignItems(itemIds: number[], categoryId: any): Observable<void> {
    const url = `${this.apiUrl}/assign/items`;
    const params = new HttpParams().set('categoryId', categoryId.toString());
    return this.httpClient.patch<void>(url, itemIds, { params });
  }

  getNewPreview(state: GridState) {
    if (state) {
      return this.httpClient.get<GridDataResult>(
        `${this.apiUrl}/new?${toDataSourceRequestString(state)}`,
      );
    }
    return this.httpClient.get<GridDataResult>(`${this.apiUrl}/new`);
  }

  downloadDocument(documentPath: string): Observable<{ url: string }> {
    return this.httpClient.get<{ url: string }>(
      `${this.apiUrl}/download-document?path=${documentPath}`,
    );
  }

  removeDocument(itemId: number, documentPath: string): Observable<void> {
    const url = `${this.apiUrl}/${itemId}/remove-document/${documentPath}`;
    return this.httpClient.put<void>(url, null);
  }

  getMachineDependencies(state: GridState): Observable<GridDataResult> {
    return this.httpClient.get<GridDataResult>(
      `${this.apiUrl}/machine-dependencies?${toDataSourceRequestString(state)}`,
    );
  }
}
